<app-custom-names-tabs objectType="navigation"></app-custom-names-tabs>
